import axiosClient from '../api/axiosClient';
import API from '../Constants/apiRoutes';

/**
 * Tech Support & Issues (CIO office) - Sai's spec section 4.
 * Live backend (contract verified against Swagger):
 *   ticket: { ticketNumber, clientId, clientName, accountNumber, occurredAtUtc,
 *             issue, status, assignedToUserId, resolvedAtUtc, history[] }
 */
const ticketService = {
  /** GET support-tickets?clientId=&status=&page=&pageSize= -> { items, page, pageSize, totalCount } */
  getTickets: async ({ clientId, status, page = 1, pageSize = 20 } = {}) => {
    const params = { page, pageSize };
    if (clientId !== undefined && clientId !== null && clientId !== '') params.clientId = clientId;
    if (status !== undefined && status !== null && status !== '') params.status = status;
    const { data } = await axiosClient.get(API.tickets.base, { params });
    return data;
  },

  /** POST support-tickets -> { clientId, issue, occurredAtUtc } (ticket raised against a client). */
  createTicket: async (payload) => {
    const { data } = await axiosClient.post(API.tickets.base, payload);
    return data;
  },

  /** GET support-tickets/{id} -> ticket detail incl. history[]. */
  getTicket: async (id) => {
    const { data } = await axiosClient.get(API.tickets.detail(id));
    return data;
  },

  /** PATCH support-tickets/{id}/status -> { status (numeric), note }. */
  setStatus: async (id, status, note) => {
    const { data } = await axiosClient.patch(API.tickets.status(id), { status, note });
    return data;
  },

  /** PATCH support-tickets/{id}/assignment -> { assignedToUserId, note }. */
  assign: async (id, assignedToUserId, note) => {
    const { data } = await axiosClient.patch(API.tickets.assignment(id), { assignedToUserId, note });
    return data;
  },

  /** GET support-tickets/assignees -> support staff who can be assigned tickets. */
  getAssignees: async () => {
    const { data } = await axiosClient.get(API.tickets.assignees);
    return Array.isArray(data) ? data : data?.items || [];
  },
};

export default ticketService;
